import React from 'react';
import styles from './styles.cssm';

const DisplayValue = ({
  caffeineDisclaimerId,
  caffeineElementId,
  caffeineRangeMax,
  caffeineRangeMaxUnits,
  className,
  disclaimerTitleId,
  displayValue,
  isCaffeine,
}) => {
  if (isCaffeine) {
    return (
      <p
        className={`inline ${styles.offset} ${styles.target}`}
        id={caffeineElementId}
      >
        <span className={className}>
          {displayValue}
          {caffeineRangeMax &&
            ` - ${caffeineRangeMax} ${caffeineRangeMaxUnits}`}
          <a
            aria-labelledby={disclaimerTitleId}
            className={`text-noUnderline `}
            href={`#${caffeineDisclaimerId}`}
          >
            {'**'}
          </a>
        </span>
      </p>
    );
  }
  return <span className={className}>{displayValue}</span>;
};

export default DisplayValue;
